import { activityDateMillis } from "./crmRepairConsoleUtils";

export function classifyActivityDate(value, exists = true) {
  if (!exists) return "missing";
  if (value === null) return "explicit_null";
  if (value && typeof value === "object" &&
      (value._methodName || value._delegate?._methodName)) return "sentinel_map";
  if (typeof value?.toMillis === "function" && activityDateMillis(value) != null) return "firestore_timestamp";
  const iso = typeof value === "string" && /^\d{4}-\d{2}-\d{2}(?:T.*(?:Z|[+-]\d{2}:\d{2}))?$/.test(value);
  const calendarValid = iso && (() => {
    const [year, month, day] = value.slice(0, 10).split("-").map(Number);
    return month >= 1 && month <= 12 && day >= 1 && day <= new Date(Date.UTC(year, month, 0)).getUTCDate();
  })();
  const unambiguous = value instanceof Date || calendarValid;
  return unambiguous && activityDateMillis(value) != null ? "historical_date" : "invalid_or_ambiguous";
}

// Preview only; nulls and sentinel maps must never enter the normal missing-date repair.
export function buildQuoteActivityMigrationPreview(id, record = {}) {
  const classification = classifyActivityDate(record.lastActivityAt,
    Object.prototype.hasOwnProperty.call(record, "lastActivityAt"));
  const candidates = ["updatedAt", "lastEditedAt", "savedAt", "createdAt", "quoteDate", "quotationDate", "date"]
    .map((source) => ({ source, value: record[source], classification: classifyActivityDate(record[source]) }))
    .filter((candidate) => ["firestore_timestamp", "historical_date"].includes(candidate.classification));
  const selected = candidates[0];
  const validCurrent = ["firestore_timestamp", "historical_date"].includes(classification);
  const created = candidates.find((candidate) => candidate.source === "createdAt");
  const conflict = selected && created && activityDateMillis(selected.value) < activityDateMillis(created.value);
  const reviewClass = validCurrent ? "A" : !selected ? "D" : classification !== "missing" || conflict ||
    ["updatedAt", "lastEditedAt", "savedAt"].includes(selected.source) ? "C" : "B";
  return {
    id, quoteNo: record.quoteNo || record.quoteNoString || "",
    current: record.lastActivityAt ?? null, classification,
    proposed: validCurrent ? null : selected?.value ?? null,
    source: validCurrent ? "none" : selected?.source || "none",
    reviewClass,
    proposedField: "listSortAt (proposal only, not active)",
    manualReviewRequired: reviewClass === "C" || reviewClass === "D",
    confidence: validCurrent ? "No change" : classification === "missing" && selected ? "Historical candidate" : "Manual Only",
    reason: validCurrent ? "Existing activity date is valid." : !selected
      ? "No unambiguous historical date found."
      : classification === "missing" ? reviewClass === "C"
        ? "Unverified edit/save history or conflicting chronology. Historical browse-time writes may have affected this date. Manual review required."
        : "Creation/issue-date fallback is usable for sorting only, not verified business activity. Separate approval required."
      : "Explicit null, sentinel, or invalid value requires separate manual review.",
    candidates,
  };
}
